var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.397,
    height: 26.315,
    viewBox: "0 0 26.397 26.315",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97",
    transform: "translate(-6001.497 -6487.962)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    d: "M0,0H26.4a0,0,0,0,1,0,0V15.311a.613.613,0,0,1-.613.613H.613A.613.613,0,0,1,0,15.311V0A0,0,0,0,1,0,0Z",
    transform: "translate(6001.497 6498.354)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 3.017,
    height: 6.045,
    rx: 0.815,
    transform: "translate(6006.392 6487.962)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 3.017,
    height: 6.045,
    rx: 0.815,
    transform: "translate(6019.981 6487.962)",
    fill: "#1a1a1a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M6027.894,6496.1v-3.292a.613.613,0,0,0-.613-.613H6002.11a.612.612,0,0,0-.613.613v3.292Z",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M6009.409,6506.315l3.774,3.249,6.8-6.543",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.835
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/iconCalendar.d431ae35143d9eff5808db1471f4cc13.svg";
export { ForwardRef as ReactComponent };